
import {
    RefreshIcon,
} from '@heroicons/react/outline'

import {Fade} from 'react-reveal'
import './Features.scss'
import {CashIcon, ChatIcon, EmojiHappyIcon, MoonIcon, UserIcon} from "@heroicons/react/solid";

const features = [
    { name: 'Game Night', icon: MoonIcon, description: 'Limited time live game night with high stakes and an even higher reward.' },
    { name: 'Chat', icon: ChatIcon, description: 'Team chat rooms to discuss upcoming games and events' },
    { name: 'Daily Challenges', icon: RefreshIcon, description: 'High reward daily challenges that always feel fresh and allows you to earn more coins.' },
    { name: 'Social Media Challenges', icon: EmojiHappyIcon, description: 'Challenge other users for a quiz face off by sharing the game code and earn rewards..' },
    { name: 'Team Leaderboard', icon: UserIcon, description: 'Team based leaderboard to find out who knows the most about a team.' },
    { name: 'Cosmetic Items', icon: CashIcon, description: 'Cosmetic items to add flair to your persona.' },
]

export const Features = () => {
    return (
        <div className="relative bg-white py-1 sm:py-24 lg:py-1">
            <div className="mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
                <h2 className="text-base font-semibold tracking-wider theme-c uppercase">Features</h2>
                <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
                    Upcoming Features
                </p>
                <p className="mt-5 max-w-prose mx-auto text-xl text-gray-500">
                    We have a lot of ideas which will be added into the app very soon.
                </p>
                <div className="mt-12">
                    <Fade>
                        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                            {features.map((feature) => (
                                <div key={feature.name} className="pt-6">
                                    <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 feature-card">
                                        <div className="-mt-6">
                                            <div>
                                              <span className="inline-flex feature-icon items-center justify-center p-3 theme rounded-md shadow-lg">
                                                <feature.icon className="h-6 w-6 text-white " aria-hidden="true" />
                                              </span>
                                            </div>
                                            <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">{feature.name}</h3>
                                            <p className="mt-5 text-base text-gray-500">
                                                {feature.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Fade>
                </div>
            </div>
        </div>
    )
}
